import { NavLink } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import MainCard from "components/MainCard";
import { useEnumApi } from "contexts/EnumApiContext";

const AlertListCard = ({equipmentAlerts}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    return (
        <div>
            <MainCard className="center_table" content={false}>
                <TableContainer>
                <Table sx={{ minWidth: 500 }} aria-label="simple table" className="base_link">
                    <TableHead>
                    <TableRow>
                        <TableCell>{t('message.common.subtitle.dateAt')}</TableCell>
                        <TableCell align="center">{t('message.common.subtitle.alertType')}</TableCell>
                        <TableCell align="center">{t('message.common.subtitle.alertCategory')}</TableCell>
                        <TableCell align="center" style={{width:"170px"}}>{t('message.common.subtitle.description')}</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {equipmentAlerts && equipmentAlerts.map((alert, i) => {
                        let linkUrl = "/equipment-alert-history-tracking/"+alert.id;
                        let statusClassName = '';
                        if (alert.status) {
                            if (alert.status === 'D' || alert.status === 'F') {
                                statusClassName = 'condition1';
                            } else if (alert.status === 'M') {
                                if (alert.fllwActionType) {
                                    if (alert.fllwActionType === 'O1_WAIT')
                                        statusClassName = 'condition1';
                                    else if (alert.fllwActionType === 'O2_OBSERVE')
                                        statusClassName = 'condition3';
                                    else if (alert.fllwActionType === 'O3_MNT')
                                        statusClassName = 'condition5';
                                    else if (alert.fllwActionType === 'O4_NORMAL')
                                        statusClassName = 'condition6';
                                }
                            }
                        }

                        let alertDtl = (alert.alertDtl || '');
                        // if (alert.alertType === 'IOT' && alertDtl.indexOf(t('message.common.text.iot.diagnosis')) !== -1) {
                            if (alert.equipmentPartFaultCodes && alert.equipmentPartFaultCodes.length > 0) {
                                // alertDtl += (alertDtl && "<br/>");
                                alert.equipmentPartFaultCodes.map(function(codes, idx) {
                                    alertDtl += codes.equipmentPart?.masterEquipmentPart?.name+'['+codes.equipmentPart?.position+']-';
                                    // alertDtl += codes.diagnosisCode?.subCategoryNm+'('+codes.diagnosisCode?.categoryNm+')<br />';
                                    alertDtl += codes.diagnosisCode?.subCategoryNm+'('+codes.diagnosisCode?.categoryNm+')';
                                })
                            }
                        // }
                        return (
                        <TableRow hover key={i} style={{verticalAlign:"top"}}>
                            <TableCell align="center"><NavLink href={linkUrl}>{alert.alertedAt && dayjs(alert.alertedAt).format("YYYY-MM-DD HH:mm")}</NavLink></TableCell>
                            <TableCell align="center"><NavLink href={linkUrl}>{alert.alertType && getEnumValueByEnumNameAndCode("AlertType", alert.alertType) && getEnumValueByEnumNameAndCode("AlertType", alert.alertType)[0].title}</NavLink></TableCell>
                            <TableCell align="center"><NavLink href={linkUrl}>{alert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", alert.alertCategory) && getEnumValueByEnumNameAndCode("AlertCategory", alert.alertCategory)[0].title}</NavLink></TableCell>
                            <TableCell style={{whiteSpace:"pre-line",textAlign:"left"}}><NavLink href={linkUrl} dangerouslySetInnerHTML={ {__html: alertDtl } }></NavLink></TableCell>
                        </TableRow>
                    )
                    })}
                    </TableBody>
                </Table>
                </TableContainer>
            </MainCard>
        </div>
    )
}

export default AlertListCard;